export const DEFAULT_RANDOM_LENGTH = 13;

export const RANDOM_LETTERS =
  "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

export const RANDOM_ALPHANUM = `${RANDOM_LETTERS}0123456789`;

export const RANDOM_SYMBOL = `${RANDOM_ALPHANUM}_-`;

function fillRandomBytes(length: number) {
  if (typeof crypto === "undefined" || !("getRandomValues" in crypto)) {
    throw new Error(
      "缺少 Web Crypto（crypto.getRandomValues），无法生成安全随机数",
    );
  }

  const bytes = new Uint8Array(length);

  crypto.getRandomValues(bytes);

  return bytes;
}

function randomIndexes(count: number, bound: number): number[] {
  if (!Number.isInteger(bound) || bound <= 0 || bound > 256) {
    throw new RangeError(`随机下标上界必须是 1..256 的整数，收到 ${bound}`);
  }

  const limit = Math.floor(256 / bound) * bound;
  const out: number[] = [];

  while (out.length < count) {

    const bytes = fillRandomBytes(Math.max(count - out.length, 8));

    for (const byte of bytes) {
      if (out.length >= count) break;
      if (byte < limit) out.push(byte % bound);
    }
  }

  return out;
}

export function randomChars(length: number, charset: string): string {
  if (length <= 0) {
    return "";
  }

  return randomIndexes(length, charset.length)
    .map((index) => charset[index]!)
    .join("");
}

function pickRandomString(length: number, charset: string): string {

  const head = randomChars(1, RANDOM_LETTERS);

  return head + randomChars(length - 1, charset);
}

export function randomKeyPattern(length = DEFAULT_RANDOM_LENGTH): RegExp {
  if (length <= 1) {
    return /^[a-zA-Z]$/;
  }

  return new RegExp(`^[a-zA-Z][a-zA-Z0-9]{${length - 1}}$`);
}

export function randomSymbolKeyPattern(length = DEFAULT_RANDOM_LENGTH): RegExp {
  if (length <= 1) {
    return /^[a-zA-Z]$/;
  }

  return new RegExp(`^[a-zA-Z][a-zA-Z0-9_-]{${length - 1}}$`);
}

export function generateRandomKey(length = DEFAULT_RANDOM_LENGTH): string {
  return pickRandomString(length, RANDOM_ALPHANUM);
}

export function generateRandomSymbolKey(length = DEFAULT_RANDOM_LENGTH): string {
  return pickRandomString(length, RANDOM_SYMBOL);
}

export function generateUniqueRandomKey(
  used: Set<string>,
  length = DEFAULT_RANDOM_LENGTH,
  options?: { symbols?: boolean },
): string {
  const generate = options?.symbols
    ? generateRandomSymbolKey
    : generateRandomKey;
  let key = "";

  do {
    key = generate(length);
  } while (used.has(key));

  used.add(key);
  return key;
}
